/* Simaru Größenfinder – Produktseiten-Block (Archetype/Expanse)
   Keine Abhängigkeiten. Wird von snippets/simaru-groessenfinder.liquid geladen.
   22.10.2026: Texte vereinfacht, Gürtel-Gesamtlänge (Bundmaß + 15 cm), Schere statt Ausdruck-Text. */
(function () {
  'use strict';
  if (window.customElements && customElements.get('simaru-size-finder')) return;

  /* ---------- Hilfsfunktionen ---------- */
  var LS_KEY = 'simaru-gf';
  var store = {
    get: function () { try { return JSON.parse(localStorage.getItem(LS_KEY) || '{}'); } catch (e) { return {}; } },
    set: function (o) { try { var s = store.get(); for (var k in o) s[k] = o[k]; localStorage.setItem(LS_KEY, JSON.stringify(s)); } catch (e) {} }
  };
  var num = function (s) { return s == null ? null : parseFloat(String(s).replace(',', '.')); };
  var fmt = function (n, d) { d = d || 0; return Number(n).toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d }); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var round = function (v, step) { return Math.round(v / step) * step; };

  /* Gürtel: Gesamtlänge = Bundmaß (= Gürtelgröße) + 15 cm */
  var BELT_EXTRA = 15;

  var SCISSORS = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false" style="vertical-align:-3px;margin-right:4px"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M20 4 8.1 15.9M14.5 14.5 20 20M8.1 8.1 12 12"/></svg>';
  var ARR = ' <span aria-hidden="true">→</span> ';

  var RE_BELT = /Bundma(?:ß|ss)\s*:?\s*(\d{2,3})\s*(?:\(([^)]+)\))?/i;
  var RE_BRACELET = /^\s*([0-9]*X*[SML](?:\s*-\s*[0-9]*X*[SML])?)\s*-?>\s*Handgelenk(?:umfang)?\s*(?:bis\s*([\d.,]+)|([\d.,]+)\s*-\s*([\d.,]+))\s*cm(?:[^0-9]*?L(?:ä|ae)nge\s*([\d.,]+)\s*cm)?/i;

  function parseSize(val) {
    if (!val) return null;
    var m = RE_BELT.exec(val);
    if (m) return { kind: 'belt', key: m[1], cm: +m[1], label: (m[2] || '').trim(), raw: val };
    m = RE_BRACELET.exec(val);
    if (m) {
      var lo = m[2] ? null : num(m[3]);
      var hi = m[2] ? num(m[2]) : num(m[4]);
      return {
        kind: 'bracelet', key: m[1].replace(/\s+/g, ''), code: m[1].replace(/\s+/g, ''),
        lo: lo, hi: hi, mid: lo == null ? hi - 0.5 : (lo + hi) / 2, len: num(m[5]), raw: val
      };
    }
    return null;
  }

  var SWATCH = {
    'schwarz': '#1f1b19', 'braun': '#5a3622', 'braun-used': 'linear-gradient(135deg,#7a5236,#4e3020 60%,#8a6244)',
    'hellbraun': '#a8703f', 'hellbraun-mix': 'linear-gradient(135deg,#c08a52,#8a5a30)', 'braun-mix': 'linear-gradient(135deg,#6e4a33,#3e2617)',
    'beige': '#d9c6a5', 'granada': '#7a2e2a', 'cognac': '#9a5a2a', 'grau': '#8a8a86', 'blau': '#2f4b7a',
    'amber': '#c08a3a', 'tuerkis': '#2f8f8a', 'türkis': '#2f8f8a', 'natur': '#c9a77c'
  };

  /* Modell eines Produkts: welche Option ist Größe, Farbe, Zusatz (z. B. Gravur) */
  function buildModel(p) {
    var sizeIdx = -1, colorIdx = -1, extra = [];
    for (var i = 0; i < p.options.length; i++) {
      if (p.variants.some(function (v) { return parseSize(v.o[i]); })) { sizeIdx = i; break; }
    }
    if (sizeIdx < 0) return null;
    for (var j = 0; j < p.options.length; j++) {
      if (j === sizeIdx) continue;
      var vals = p.variants.map(function (v) { return v.o[j] || ''; });
      var named = /^(color|colour|farbe)$/i.test(p.options[j]);
      if (!named && vals.some(function (x) { return /gravur/i.test(x); })) extra.push(j);
      else if (colorIdx < 0) colorIdx = j;
      else extra.push(j);
    }
    p.sizeIdx = sizeIdx; p.colorIdx = colorIdx; p.extra = extra;
    p.sizes = sizeList(p);
    p.kind = p.sizes.length ? p.sizes[0].kind : null;
    return p.kind ? p : null;
  }
  function sizeList(p) {
    var seen = {}, out = [];
    p.variants.forEach(function (v) {
      var s = parseSize(v.o[p.sizeIdx]);
      if (s && !seen[s.key]) { seen[s.key] = 1; out.push(s); }
    });
    out.sort(function (a, b) { return a.kind === 'belt' ? a.cm - b.cm : a.hi - b.hi; });
    return out;
  }
  function colorsOf(p) {
    if (p.colorIdx < 0) return [p.title];
    var seen = {}, out = [];
    p.variants.forEach(function (v) { var c = v.o[p.colorIdx]; if (c && !seen[c]) { seen[c] = 1; out.push(c); } });
    return out;
  }
  function findVariant(p, color, size) {
    var list = p.variants.filter(function (v) {
      if (p.colorIdx >= 0 && v.o[p.colorIdx] !== color) return false;
      var s = parseSize(v.o[p.sizeIdx]);
      return s && s.key === size.key;
    });
    if (!list.length) return null;
    if (p.extra.length) {
      var plain = list.filter(function (v) { return p.extra.every(function (i) { return !v.o[i] || /ohne/i.test(v.o[i]); }); });
      if (plain.length) list = plain;
    }
    return list.find(function (v) { return v.a; }) || list[0];
  }

  /* ---------- Empfehlungslogik ---------- */
  function recommendBelt(sizes, m) {
    var vals = sizes.map(function (s) { return s.cm; });
    if (m < vals[0] - 3 || m > vals[vals.length - 1] + 3) return { out: true };
    var i = 0;
    vals.forEach(function (v, k) { if (Math.abs(v - m) < Math.abs(vals[i] - m)) i = k; });
    var diff = m - vals[i], between = null;
    var half = vals.length > 1 ? (vals[1] - vals[0]) / 2 : 2.5;
    if (Math.abs(diff) >= half * 0.6) {
      if (diff > 0 && i < vals.length - 1) { between = [i, i + 1]; i = i + 1; }
      else if (diff < 0 && i > 0) { between = [i - 1, i]; }
    }
    var edge = !between && Math.abs(diff) >= half * 0.6 ? (diff > 0 ? 'top' : 'bottom') : null;
    return { i: i, between: between, edge: edge };
  }
  function recommendBracelet(sizes, v) {
    var minV = (sizes[0].lo != null ? sizes[0].lo : sizes[0].hi - 2) - 0.3;
    var maxV = sizes[sizes.length - 1].hi + 0.3;
    if (v < minV || v > maxV) return { out: true };
    var c = sizes.map(function (s, i) { return { s: s, i: i }; })
      .filter(function (x) { return (x.s.lo == null || v > x.s.lo) && v <= x.s.hi + 0.3; });
    if (!c.length) c = sizes.map(function (s, i) { return { s: s, i: i }; });
    c.sort(function (a, b) { return Math.abs(a.s.mid - v) - Math.abs(b.s.mid - v); });
    var i = c[0].i, between = null, s = sizes[i];
    var next = sizes[i + 1];
    if (next && next.lo != null && next.lo >= s.hi - 0.01 && Math.abs(v - s.hi) <= 0.15) { between = [i, i + 1]; i = i + 1; }
    return { i: i, between: between };
  }
  function wraps(sizes) {
    var s = sizes.find(function (x) { return x.len; });
    return s ? Math.max(1, Math.min(3, Math.round(s.len / s.hi))) : 1;
  }
  /* Gesamtlänge = n × Handgelenk (Mitte der Größe) + Zugabe – abgeleitet aus euren Größentabellen:
     einfach S 19 cm = 15,5 + 3,5 · doppelt S 37 cm = 2 × 15,5 + 6 · dreifach S-M 58 cm = 3 × 16,25 + 9,25 */
  var WRAP_OFFSET = { 1: 3.5, 2: 6, 3: 9.25 };
  function ownedDefault(n) { return round(n * 16.5 + WRAP_OFFSET[n], 0.5); }

  /* Eigenes Armband derselben Art: direkt über die Gesamtlänge vergleichen */
  function recommendByLength(sizes, L) {
    var list = sizes.map(function (s, i) { return { s: s, i: i }; }).filter(function (x) { return x.s.len; });
    if (list.length < 2) return null;
    list.sort(function (a, b) { return a.s.len - b.s.len; });
    var step = list[1].s.len - list[0].s.len;
    if (L < list[0].s.len - step || L > list[list.length - 1].s.len + step) return { out: true };
    var k = 0;
    list.forEach(function (x, j) { if (Math.abs(x.s.len - L) < Math.abs(list[k].s.len - L)) k = j; });
    var diff = L - list[k].s.len, between = null;
    if (Math.abs(diff) >= step * 0.4) {
      if (diff > 0 && k < list.length - 1) { between = [list[k].i, list[k + 1].i]; k = k + 1; }
      else if (diff < 0 && k > 0) { between = [list[k - 1].i, list[k].i]; }
    }
    var edge = !between && Math.abs(diff) >= step * 0.4;
    return { i: list[k].i, between: between, exact: Math.abs(diff) < 0.25, edge: edge };
  }
  var GIFT = { zierlich: 15, damen: 16, herren: 17.5, kraeftig: 18.6 };

  /* ---------- Element ---------- */
  class SizeFinder extends HTMLElement {}

  SizeFinder.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;
    var data;
    try { data = JSON.parse(this.querySelector('[data-sgf-data]').textContent); } catch (e) { return; }
    this.cfg = data.settings || {};
    var products = data.products.map(buildModel).filter(Boolean);
    this.cur = products.find(function (p) { return p.current; });
    if (!this.cur) return;
    var kind = this.cur.kind;
    this.products = products.filter(function (p) { return p.kind === kind; });
    this.kind = kind;
    this.sizes = this.cur.sizes;
    this.formId = this.dataset.formId;
    this.sectionId = this.dataset.sectionId;

    var saved = store.get();
    var n = wraps(this.sizes);
    this.s = {
      method: kind === 'belt' ? 'old' : 'wrist',
      belt: saved.belt || 90, wrist: saved.wrist || 17,
      w: 34, low: false, fit: 'normal', gift: 'herren',
      ownedType: n, owned: ownedDefault(n),
      color: null
    };

    this.colorMap = [];
    var self = this;
    this.products.forEach(function (p) { colorsOf(p).forEach(function (c) {
      if (!self.colorMap.some(function (x) { return x.color === c; })) self.colorMap.push({ color: c, product: p });
    }); });

    this.dialog = this.querySelector('dialog');
    this.root = this.querySelector('[data-sgf-root]');
    this.hidden = false;
    this.querySelector('[data-sgf-open]').addEventListener('click', function () { self.open(); });
    this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.dialog.close(); });
    this.dialog.addEventListener('close', function () { self.renderMemo(); });
    this.renderMemo();
    this.track('view');
  };

  SizeFinder.prototype.money = function (cents) {
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: this.cfg.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return fmt(cents / 100, 2) + ' €'; }
  };
  SizeFinder.prototype.form = function () { return document.getElementById(this.formId); };
  SizeFinder.prototype.currentVariant = function () {
    var f = this.form(), input = f && f.querySelector('[name="id"]');
    var id = input ? +input.value : (+new URLSearchParams(location.search).get('variant'));
    return this.cur.variants.find(function (v) { return v.id === id; }) || this.cur.variants[0];
  };
  SizeFinder.prototype.currentColor = function () {
    var v = this.currentVariant();
    return this.cur.colorIdx >= 0 ? v.o[this.cur.colorIdx] : this.cur.title;
  };
  SizeFinder.prototype.track = function (step, extra) {
    try {
      var payload = { step: step, kind: this.kind, product_id: this.cur.id };
      if (extra) for (var k in extra) payload[k] = extra[k];
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('simaru_groessenfinder', payload);
    } catch (e) {}
  };

  /* ---------- Öffnen / Schließen ---------- */
  SizeFinder.prototype.open = function () {
    this.s.color = this.currentColor();
    this.render();
    if (this.dialog.showModal) this.dialog.showModal(); else this.dialog.setAttribute('open', '');
    this.track('open');
  };
  SizeFinder.prototype.close = function () { if (this.dialog.open) this.dialog.close(); };

  /* ---------- Gemerkte Größe auf der Produktseite ---------- */
  SizeFinder.prototype.renderMemo = function () {
    var memo = this.querySelector('[data-sgf-memo]');
    if (!this.cfg.memo) return;
    var saved = store.get(), r, size;
    if (this.kind === 'belt' && saved.belt) { r = recommendBelt(this.sizes, saved.belt); if (!r.out) size = this.sizes[r.i]; }
    if (this.kind === 'bracelet' && saved.wrist) { r = recommendBracelet(this.sizes, saved.wrist); if (!r.out) size = this.sizes[r.i]; }
    if (!size) { memo.hidden = true; return; }
    var label = this.kind === 'belt' ? size.cm + (size.label ? ' (' + size.label + ')' : '') : size.code;
    memo.innerHTML = 'Deine Größe: <b>' + esc(label) + '</b>. <button type="button" class="sgf__link" data-sgf-pick>Auswählen</button>';
    memo.hidden = false;
    var self = this;
    memo.querySelector('[data-sgf-pick]').onclick = function () {
      var v = findVariant(self.cur, self.currentColor(), size);
      if (v) self.applyToPicker(v);
      self.track('memo_pick');
    };
  };

  /* ---------- Darstellung ---------- */
  var METHODS = {
    belt: [
      { k: 'old', l: 'Alten Gürtel messen', h: 'Von der Schnalle bis zum Loch messen, das du nutzt.' },
      { k: 'tape', l: 'Am Bund messen', h: 'Maßband über der Hose da anlegen, wo der Gürtel sitzt.' },
      { k: 'pants', l: 'Nur Hosengröße bekannt', h: 'Wir schätzen. Messen ist genauer.' }
    ],
    bracelet: [
      { k: 'wrist', l: 'Handgelenk messen', h: 'Papierstreifen' + ARR + 'eng ums Handgelenk' + ARR + 'markieren' + ARR + 'mit Lineal messen.' },
      { k: 'own', l: 'Mein Armband messen', h: 'Ein Armband, das gut passt, von Ende zu Ende messen.' },
      { k: 'gift', l: 'Ist ein Geschenk', h: 'Wir nehmen eine typische Größe.' }
    ]
  };

  SizeFinder.prototype.render = function () {
    var self = this, list = METHODS[this.kind];
    var title = this.kind === 'belt' ? 'Welche Gürtelgröße passt dir?' : 'Welche Armbandgröße passt dir?';
    var sub = this.kind === 'belt' ? 'Bundmaß = Gürtelgröße. Der Gürtel ist insgesamt ' + BELT_EXTRA + ' cm länger.' : esc(this.cur.title);
    this.root.innerHTML =
      '<div class="sgf__head"><h2 class="sgf__title">' + title + '</h2>' +
      '<button type="button" class="sgf__close" data-sgf-close aria-label="Schließen">×</button></div>' +
      '<p class="sgf__sub">' + sub + '</p>' +
      '<div class="sgf__chips" role="group" aria-label="Messmethode">' +
      list.map(function (m) { return '<button type="button" class="sgf__chip" data-m="' + m.k + '" aria-pressed="' + (m.k === self.s.method) + '">' + m.l + '</button>'; }).join('') +
      '</div><p class="sgf__how">' + list.find(function (m) { return m.k === self.s.method; }).h +
      (this.kind === 'bracelet' && this.s.method === 'wrist' && this.cfg.measurePdf ? ' <a class="sgf__link" href="' + esc(this.cfg.measurePdf) + '" target="_blank" rel="noopener" title="Maßband zum Ausdrucken">' + SCISSORS + 'Maßband drucken</a>' : '') + '</p>' +
      '<div data-sgf-input></div><section class="sgf__result" data-sgf-result aria-live="polite"></section>';
    this.root.querySelector('[data-sgf-close]').onclick = function () { self.close(); };
    this.root.querySelectorAll('[data-m]').forEach(function (b) {
      b.onclick = function () { self.s.method = b.dataset.m; self.render(); self.track('method', { method: b.dataset.m }); };
    });
    this.renderInput();
  };

  SizeFinder.prototype.chips = function (opts, cur, label, onPick) {
    var d = document.createElement('div');
    d.className = 'sgf__field';
    d.innerHTML = '<span class="sgf__label">' + label + '</span><div class="sgf__chips">' +
      opts.map(function (o) { return '<button type="button" class="sgf__chip" data-k="' + o[0] + '" aria-pressed="' + (String(o[0]) === String(cur)) + '">' + o[1] + '</button>'; }).join('') + '</div>';
    var self = this;
    d.querySelectorAll('button').forEach(function (b) {
      b.onclick = function () {
        d.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        onPick(b.dataset.k); self.renderResult();
      };
    });
    return d;
  };

  SizeFinder.prototype.tape = function (o) {
    var box = document.createElement('div'), self = this;
    box.className = 'sgf__tapebox';
    var pct = function (v) { return ((v - o.min) / (o.max - o.min)) * 100; };
    var ticks = '', minor = o.minor;
    for (var v = o.min; v <= o.max + 1e-9; v = Math.round((v + minor) * 10) / 10) {
      var big = Math.abs(v % o.major) < 1e-6, mid = !big && Math.abs(v % (o.major / 2)) < 1e-6;
      ticks += '<i class="sgf__tick ' + (big ? 'is-big' : mid ? 'is-mid' : '') + '" style="left:' + pct(v) + '%"></i>';
      if (big) ticks += '<span class="sgf__tick-l" style="left:' + pct(v) + '%">' + fmt(v) + '</span>';
    }
    box.innerHTML = '<div class="sgf__tape">' + ticks + '<i class="sgf__marker" style="left:' + pct(o.value) + '%"></i>' +
      '<input type="range" min="' + o.min + '" max="' + o.max + '" step="' + o.step + '" value="' + o.value + '" aria-label="' + o.aria + '"></div>' +
      '<div class="sgf__valrow"><div class="sgf__num"><button type="button" aria-label="weniger">−</button>' +
      '<input type="number" inputmode="decimal" min="' + o.min + '" max="' + o.max + '" step="' + o.step + '" value="' + o.value + '" aria-label="' + o.aria + '">' +
      '<button type="button" aria-label="mehr">+</button></div><span class="sgf__unit">cm</span></div>';
    var r = box.querySelector('input[type=range]'), n = box.querySelector('input[type=number]'), mk = box.querySelector('.sgf__marker');
    var btns = box.querySelectorAll('.sgf__num button');
    var set = function (v) {
      v = Math.min(o.max, Math.max(o.min, round(v, o.step)));
      v = Math.round(v * 10) / 10;
      r.value = v; n.value = v; mk.style.left = pct(v) + '%';
      o.onInput(v); self.renderResult();
    };
    r.addEventListener('input', function () { set(+r.value); });
    n.addEventListener('change', function () { var v = num(n.value); if (!isNaN(v)) set(v); });
    btns[0].onclick = function () { set(+r.value - o.step); };
    btns[1].onclick = function () { set(+r.value + o.step); };
    return box;
  };

  SizeFinder.prototype.renderInput = function () {
    var a = this.root.querySelector('[data-sgf-input]'), s = this.s, self = this;
    a.innerHTML = '';
    if (this.kind === 'belt') {
      if (s.method === 'pants') {
        var f = document.createElement('div');
        f.className = 'sgf__field';
        var opts = '';
        for (var w = 26; w <= 46; w++) opts += '<option value="' + w + '"' + (w === s.w ? ' selected' : '') + '>W' + w + '</option>';
        f.innerHTML = '<label class="sgf__label" for="SgfW-' + this.sectionId + '">Jeansweite</label><select class="sgf__select" id="SgfW-' + this.sectionId + '">' + opts + '</select>';
        f.querySelector('select').onchange = function (e) { s.w = +e.target.value; self.renderResult(); };
        a.appendChild(f);
        a.appendChild(this.chips([['0', 'Normal'], ['1', 'Tief auf der Hüfte']], s.low ? '1' : '0', 'Gürtel sitzt', function (k) { s.low = k === '1'; }));
      } else {
        a.appendChild(this.tape({ min: 60, max: 140, step: 0.5, minor: 1, major: 10, value: s.belt, aria: 'Bundmaß in Zentimetern', onInput: function (v) { s.belt = v; } }));
      }
    } else {
      if (s.method === 'wrist') {
        a.appendChild(this.tape({ min: 13, max: 22, step: 0.1, minor: 0.5, major: 1, value: s.wrist, aria: 'Handgelenkumfang in Zentimetern', onInput: function (v) { s.wrist = v; } }));
        a.appendChild(this.chips([['eng', 'Eng'], ['normal', 'Normal'], ['locker', 'Locker']], s.fit, 'Sitz', function (k) { s.fit = k; }));
      } else if (s.method === 'own') {
        a.appendChild(this.chips([[1, '1× ums Handgelenk'], [2, '2× gewickelt'], [3, '3× gewickelt']], s.ownedType, 'Dein Armband', function (k) {
          s.ownedType = +k; s.owned = ownedDefault(s.ownedType); self.renderInput();
        }));
        var t = s.ownedType, lo = Math.floor(t * 14 + WRAP_OFFSET[t] - 1), hi = Math.ceil(t * 21 + WRAP_OFFSET[t] + 1);
        a.appendChild(this.tape({ min: lo, max: hi, step: 0.5, minor: 1, major: t === 1 ? 1 : 2, value: Math.min(hi, Math.max(lo, s.owned)), aria: 'Länge deines Armbands in Zentimetern', onInput: function (v) { s.owned = v; } }));
      } else {
        a.appendChild(this.chips([['zierlich', 'Zierlich'], ['damen', 'Damen normal'], ['herren', 'Herren normal'], ['kraeftig', 'Kräftig']], s.gift, 'Handgelenk ist', function (k) { s.gift = k; }));
      }
    }
    this.renderResult();
  };

  SizeFinder.prototype.measure = function () {
    var s = this.s;
    if (this.kind === 'belt') {
      if (s.method === 'pants') return { v: round(s.w * 2.54 + (+this.cfg.beltJeansAdd || 4) + (s.low ? 4 : 0), 0.5), est: true };
      return { v: s.belt, est: false };
    }
    if (s.method === 'wrist') return { v: s.wrist + ({ eng: -0.4, normal: 0, locker: 0.6 })[s.fit], base: s.wrist, est: false };
    if (s.method === 'own') {
      var w = (s.owned - WRAP_OFFSET[s.ownedType]) / s.ownedType;
      return { v: w, base: w, est: false, derived: true, len: s.owned, same: s.ownedType === wraps(this.sizes) };
    }
    return { v: GIFT[s.gift], base: GIFT[s.gift], est: true };
  };

  SizeFinder.prototype.renderResult = function () {
    var box = this.root.querySelector('[data-sgf-result]'), self = this, cfg = this.cfg;
    var m = this.measure(), r, size, why, flag = '', viz = '', sizeText, sub;
    var mail = esc(cfg.supportEmail || 'support@simaru.de');
    var mailLink = '<a href="mailto:' + mail + '">' + mail + '</a>';

    if (this.kind === 'belt') {
      r = recommendBelt(this.sizes, m.v);
      if (r.out) {
        box.innerHTML = '<p class="sgf__why sgf__warn">Für ' + fmt(m.v, 1) + ' cm gibt es dieses Modell nicht (nur ' + this.sizes[0].cm + '–' + this.sizes[this.sizes.length - 1].cm + ' cm). Schreib uns: ' + mailLink + '</p>';
        this.sel = null; return;
      }
      size = this.sizes[r.i];
      sizeText = size.cm + '<small>cm</small>';
      sub = 'Gürtelgröße ' + size.cm + (size.label ? ' (' + esc(size.label) + ')' : '') + ' · Gesamtlänge ' + (size.cm + BELT_EXTRA) + ' cm';
      why = m.est
        ? 'W' + this.s.w + ' ≈ ' + fmt(m.v, 1) + ' cm Bundmaß. Deine Gürtelgröße: ' + size.cm + '.'
        : 'Bundmaß ' + fmt(m.v, 1) + ' cm = Gürtelgröße ' + size.cm + '. Du schließt im mittleren Loch.';
      if (r.between) flag = 'Zwischen ' + this.sizes[r.between[0]].cm + ' und ' + this.sizes[r.between[1]].cm + ': Nimm ' + size.cm + '. ' + esc(cfg.beltBetweenTip || '');
      else if (r.edge === 'top') flag = 'Du bist an der Obergrenze. Längere Gürtel auf Anfrage: ' + mailLink;
      else if (r.edge === 'bottom') flag = 'Du bist an der Untergrenze. ' + esc(cfg.beltBetweenTip || '');
      else if (m.est) flag = 'Nur geschätzt. Messen ist genauer.';
      if (cfg.visual) viz = this.strapSVG(m.v, size.cm);
      if (!m.est) store.set({ belt: round(m.v, 0.5) });
    } else {
      var byLen = m.derived && m.same ? recommendByLength(this.sizes, m.len) : null;
      r = byLen || recommendBracelet(this.sizes, m.v);
      if (r.out) {
        box.innerHTML = '<p class="sgf__why sgf__warn">Für ' + fmt(m.base, 1) + ' cm Handgelenk gibt es keine passende Größe. Schreib uns: ' + mailLink + '</p>';
        this.sel = null; return;
      }
      size = this.sizes[r.i];
      sizeText = esc(size.code);
      sub = size.len ? 'Gesamtlänge ' + fmt(size.len) + ' cm' : '';
      var range = size.lo == null ? 'bis ' + fmt(size.hi, size.hi % 1 ? 1 : 0) + ' cm' : fmt(size.lo, size.lo % 1 ? 1 : 0) + '–' + fmt(size.hi, size.hi % 1 ? 1 : 0) + ' cm';
      why = byLen ? 'Dein Armband: ' + fmt(m.len, 1) + ' cm. Deine Größe: ' + esc(size.code) + '.'
        : m.derived ? 'Dein Armband ≈ ' + fmt(m.base, 1) + ' cm Handgelenk. Deine Größe: ' + esc(size.code) + '.'
        : m.est ? 'Meistens passt Größe ' + esc(size.code) + '.'
        : fmt(m.base, 1) + ' cm Handgelenk = Größe ' + esc(size.code) + ' (' + range + ').';
      if (r.between) flag = 'Genau an der Grenze: Nimm die größere Größe.';
      else if (byLen && byLen.edge) flag = 'Passt nicht genau. Miss lieber dein Handgelenk.';
      else if (m.derived && !m.same) flag = 'Nur umgerechnet. Handgelenk messen ist genauer.';
      else if (m.est) flag = 'Nur geschätzt. Messen ist genauer.';
      if (cfg.visual) viz = this.rangeSVG(m.v, r.i);
      if (!m.est) store.set({ wrist: Math.round(m.base * 10) / 10 });
    }

    /* Farbe + Variante */
    if (!this.colorMap.some(function (x) { return x.color === self.s.color; })) this.s.color = this.colorMap[0].color;
    var swatches = this.colorMap.map(function (x) {
      var v = findVariant(x.product, x.color, size), dis = !v || !v.a;
      var bg = SWATCH[String(x.color).toLowerCase()] || 'transparent';
      return '<button type="button" class="sgf__sw" data-c="' + esc(x.color) + '" aria-pressed="' + (x.color === self.s.color) + '"' + (dis ? ' disabled' : '') + '><i style="background:' + bg + '"></i>' + esc(x.color) + '</button>';
    }).join('');
    var entry = this.colorMap.find(function (x) { return x.color === self.s.color; });
    var variant = findVariant(entry.product, entry.color, size);
    var avail = variant && variant.a;
    var low = avail && variant.m === 'shopify' && variant.q > 0 && variant.q < 10;
    var other = entry.product !== this.cur;
    this.sel = { product: entry.product, variant: variant, size: size, measure: m };

    var stock = !variant ? 'Diese Kombination gibt es nicht.' : !avail ? 'In dieser Farbe ausverkauft.' : low ? 'Nur noch ' + variant.q + ' Stück.' : '';
    box.innerHTML =
      '<div class="sgf__res-top"><div class="sgf__size">' + sizeText + '</div><div class="sgf__res-meta"><b>' + (sub || '') + '</b></div></div>' +
      '<p class="sgf__why">' + why + '</p>' + (flag ? '<p class="sgf__flag">' + flag + '</p>' : '') +
      (viz ? '<div class="sgf__viz">' + viz + '</div>' : '') +
      (this.colorMap.length > 1 ? '<span class="sgf__label">Farbe</span><div class="sgf__swatches">' + swatches + '</div>' : '') +
      (stock ? '<p class="sgf__stock' + (low ? ' is-low' : '') + '">' + stock + '</p>' : '') +
      (other ? '<p class="sgf__note">' + esc(entry.color) + ' ist ein eigenes Produkt: ' + esc(entry.product.title) + '.</p>' : '') +
      '<div class="sgf__buy">' +
      '<button type="button" class="sgf__primary" data-sgf-add' + (avail ? '' : ' disabled') + '>In den Warenkorb' + (variant ? ', ' + this.money(variant.price) : '') + '</button>' +
      (other
        ? '<a class="sgf__ghost" href="' + esc(entry.product.url) + (variant ? '?variant=' + variant.id : '') + '">Produkt ansehen</a>'
        : '<button type="button" class="sgf__ghost" data-sgf-apply' + (variant ? '' : ' disabled') + '>Nur Größe auswählen</button>') +
      '</div><p class="sgf__toast" data-sgf-toast></p>' +
      (cfg.returnNote ? '<p class="sgf__fine">' + esc(cfg.returnNote) + '</p>' : '');

    box.querySelectorAll('.sgf__sw').forEach(function (b) { b.onclick = function () { self.s.color = b.dataset.c; self.renderResult(); }; });
    var add = box.querySelector('[data-sgf-add]'); if (add) add.onclick = function () { self.add(); };
    var ap = box.querySelector('[data-sgf-apply]'); if (ap) ap.onclick = function () { self.applyToPicker(variant); self.close(); self.renderMemo(); self.track('apply', { variant_id: variant.id }); };
  };

  /* ---------- Grafiken ---------- */
  SizeFinder.prototype.strapSVG = function (m, size) {
    var holes = Math.max(3, +this.cfg.beltHoles || 5), gap = +this.cfg.beltHoleSpacing || 2.5;
    var span = (holes - 1) / 2 * gap + 4, lo = size - span, hi = size + span, W = 560, H = 112;
    var x = function (v) { return 64 + (v - lo) / (hi - lo) * (W - 100); };
    var hs = [];
    for (var k = 0; k < holes; k++) hs.push(size + (k - (holes - 1) / 2) * gap);
    var mx = Math.max(64, Math.min(W - 30, x(m)));
    var midK = (holes - 1) / 2;
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="Gürtel mit ' + holes + ' Löchern. Dein Maß liegt beim Loch für ' + fmt(m, 1) + ' cm.">' +
      '<rect x="16" y="36" width="' + (W - 32) + '" height="36" rx="5" class="sgf-strap"/>' +
      '<path d="M22 42H' + (W - 22) + 'M22 66H' + (W - 22) + '" class="sgf-stitch"/>' +
      '<rect x="8" y="26" width="30" height="56" rx="4" class="sgf-buckle"/>' +
      hs.map(function (h, k) { return '<circle cx="' + x(h) + '" cy="54" r="' + (k === midK ? 6.5 : 4.5) + '" class="' + (k === midK ? 'sgf-hole is-mid' : 'sgf-hole') + '"/>'; }).join('') +
      '<line x1="' + mx + '" y1="20" x2="' + mx + '" y2="88" class="sgf-mark"/>' +
      '<text x="' + mx + '" y="14" text-anchor="middle" class="sgf-t-strong">Dein Maß ' + fmt(m, 1) + ' cm</text>' +
      hs.map(function (h) { return '<text x="' + x(h) + '" y="104" text-anchor="middle" class="sgf-t">' + fmt(h, h % 1 ? 1 : 0) + '</text>'; }).join('') +
      '</svg>';
  };
  SizeFinder.prototype.rangeSVG = function (v, idx) {
    var sz = this.sizes, W = 560, H = 100;
    var lo = Math.floor((sz[0].lo != null ? sz[0].lo : sz[0].hi - 2) - 0.5), hi = Math.ceil(sz[sz.length - 1].hi + 0.5);
    var x = function (t) { return 16 + (t - lo) / (hi - lo) * (W - 32); };
    var overl = sz.some(function (s, i) { return i && s.lo != null && s.lo < sz[i - 1].hi; });
    var bars = sz.map(function (s, i) {
      var a = x(s.lo != null ? s.lo : lo), b = x(s.hi), y = overl ? 26 + (i % 2) * 22 : 38, on = i === idx;
      return '<rect x="' + a + '" y="' + y + '" width="' + Math.max(8, b - a - 2) + '" height="18" rx="4" class="' + (on ? 'sgf-bar is-on' : 'sgf-bar') + '"/>' +
        '<text x="' + (a + b) / 2 + '" y="' + (y + 13) + '" text-anchor="middle" class="' + (on ? 'sgf-t-on' : 'sgf-t-strong') + '">' + esc(s.code) + '</text>';
    }).join('');
    var ticks = '';
    for (var t = lo; t <= hi; t++) ticks += '<text x="' + x(t) + '" y="' + (H - 6) + '" text-anchor="middle" class="sgf-t">' + t + '</text>';
    var mx = x(Math.max(lo, Math.min(hi, v)));
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="Größentabelle mit deinem Handgelenkumfang von ' + fmt(v, 1) + ' cm">' + bars + ticks +
      '<line x1="' + mx + '" y1="16" x2="' + mx + '" y2="' + (H - 20) + '" class="sgf-mark"/>' +
      '<text x="' + mx + '" y="11" text-anchor="middle" class="sgf-t-strong">' + fmt(v, 1) + ' cm</text></svg>';
  };

  /* ---------- Übernahme in die Produktseite ---------- */
  SizeFinder.prototype.applyToPicker = function (v) {
    if (!v) return;
    var wrap = document.getElementById('variant-selects-' + this.sectionId);
    if (wrap) {
      /* Optionen in derselben Reihenfolge wie das Theme (select/fieldset), nicht über data-index:
         Bei Dropdowns ist data-index im Theme leer („option“), weil forloop dort fehlt. */
      var els = wrap.querySelectorAll('select, fieldset');
      v.o.forEach(function (val, i) {
        if (val == null) return;
        var el = els[i];
        if (!el) return;
        if (el.tagName === 'SELECT') {
          if (el.value !== val) { el.value = val; el.dispatchEvent(new Event('change', { bubbles: true })); }
          return;
        }
        var radios = el.querySelectorAll('input[type="radio"]');
        for (var k = 0; k < radios.length; k++) {
          if (radios[k].value === val) {
            if (!radios[k].checked) { radios[k].checked = true; radios[k].dispatchEvent(new Event('change', { bubbles: true })); }
            break;
          }
        }
      });
    }
    var f = this.form(), id = f && f.querySelector('[name="id"]');
    if (id) { id.value = v.id; id.disabled = false; }
  };

  SizeFinder.prototype.props = function () {
    var m = this.sel.measure;
    var gemessen = this.kind === 'belt' ? fmt(m.v, 1) + ' cm Bund' : fmt(m.base, 1) + ' cm Handgelenk';
    return { _groessenfinder: 'ja', _gf_methode: this.s.method, _gf_mass: gemessen };
  };

  SizeFinder.prototype.add = function () {
    var self = this, sel = this.sel;
    if (!sel || !sel.variant) return;
    var props = this.props();
    this.track('add_to_cart', { variant_id: sel.variant.id, method: this.s.method });

    if (sel.product === this.cur) {
      /* Eigenes Produkt: Theme-Formular nutzen, damit Warenkorb-Drawer und Tracking wie gewohnt laufen */
      this.applyToPicker(sel.variant);
      var holder = this.querySelector('[data-sgf-props]');
      holder.innerHTML = Object.keys(props).map(function (k) {
        return '<input type="hidden" form="' + esc(self.formId) + '" name="properties[' + esc(k) + ']" value="' + esc(props[k]) + '">';
      }).join('');
      var f = this.form();
      this.close();
      setTimeout(function () {
        var id = f && f.querySelector('[name="id"]');
        if (id) { id.value = sel.variant.id; id.disabled = false; }
        var btn = f && f.querySelector('button[name="add"], [type="submit"]');
        if (btn) btn.click(); else if (f && f.requestSubmit) f.requestSubmit();
        setTimeout(function () { holder.innerHTML = ''; }, 2000);
      }, 80);
      return;
    }

    /* Anderes Farbprodukt: direkt über die AJAX-Cart-API */
    var toast = this.root.querySelector('[data-sgf-toast]');
    fetch(this.cfg.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: sel.variant.id, quantity: 1, properties: props }] })
    }).then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
      .then(function (r) {
        if (!r.ok) { toast.textContent = r.d.description || 'Das hat nicht geklappt. Bitte nochmal versuchen.'; return; }
        ['ajaxProduct:added', 'cart:build', 'cart:open'].forEach(function (n) {
          document.dispatchEvent(new CustomEvent(n, { detail: { product: r.d } }));
        });
        toast.innerHTML = 'Im Warenkorb: ' + esc(sel.product.title) + ', ' + esc(self.s.color) + '. <a href="' + esc(self.cfg.cartUrl || '/cart') + '">Zum Warenkorb</a>';
      })
      .catch(function () { toast.textContent = 'Keine Verbindung. Bitte nochmal versuchen.'; });
  };

  customElements.define('simaru-size-finder', SizeFinder);
})();